export enum CarouselAxis {
  X,
  Y
}
